import React, { useEffect, useState } from "react";

export default function Countdown({ target }) {
  const calc = () => {
    const diff = new Date(target).getTime() - Date.now();
    if (diff <= 0) return { d: 0, h: 0, m: 0, s: 0 };
    return {
      d: Math.floor(diff / (1000 * 60 * 60 * 24)),
      h: Math.floor((diff / (1000 * 60 * 60)) % 24),
      m: Math.floor((diff / (1000 * 60)) % 60),
      s: Math.floor((diff / 1000) % 60),
    };
  };
  const [t, setT] = useState(calc());
  useEffect(() => {
    const id = setInterval(() => setT(calc()), 1000);
    return () => clearInterval(id);
    // eslint-disable-next-line
  }, [target]);

  const Box = ({ v, lbl }) => (
    <div className="flex-1 min-w-0 text-center">
      <div
        data-testid={`countdown-${lbl.toLowerCase()}`}
        className="relative rounded-lg overflow-hidden"
        style={{
          background: "linear-gradient(180deg, rgba(255,255,255,0.07) 0%, rgba(255,255,255,0.02) 100%)",
          border: "1px solid rgba(0,240,255,0.18)",
          boxShadow: "inset 0 1px 0 rgba(255,255,255,0.06), 0 4px 24px rgba(0,240,255,0.08)",
        }}
      >
        {/* Top aqua bar */}
        <div className="h-0.5 w-full bg-gradient-to-r from-transparent via-[#00F0FF] to-transparent" />
        {/* Middle split line */}
        <div className="px-2 py-3 md:py-4 relative">
          <div
            className="font-display font-black text-[2.25rem] md:text-[3.25rem] leading-none tracking-tight tabular-nums text-white"
          >
            {String(v).padStart(2, "0")}
          </div>
          {/* subtle horizontal mid-line like flip clock */}
          <div className="absolute inset-x-2 top-1/2 h-px bg-[#0B1429]/40" />
        </div>
      </div>
      <div className="text-[9px] md:text-[10px] uppercase tracking-[0.3em] text-[#94A3B8] mt-2 font-semibold">
        {lbl}
      </div>
    </div>
  );

  return (
    <div className="flex items-stretch gap-2 md:gap-3 justify-center">
      <Box v={t.d} lbl="Days" />
      <Box v={t.h} lbl="Hrs" />
      <Box v={t.m} lbl="Min" />
      <Box v={t.s} lbl="Sec" />
    </div>
  );
}
